<template>
  <base-modal size="lg" hide-footer hide-header @close="$emit('close')">
    <div class="col-12" @click.stop="">
    <h3 class="editor-header">
      {{ $t('common.import_from_file') }}
    </h3>
      <div style="position: relative; height: 40vh; padding: .2em; text-align: left">
        <map-container
          ref="mapContainer"
          :find-user="false"
          @on-map-changed="mapChanged"
        />
      </div>
      <div class="col-sm-12 p-2">
        <span class="span-title">{{ $t('street_lights.station') }}</span>
        <select
          id="lightStation"
          v-model="selectedStation"
          class="form-select form-select-sm"
        >
          <option :value="null">
            {{ $t('street_lights.select_station') }}
          </option>
          <option
            v-for="station in stations"
            :key="station.value"
            :value="station.value"
          >
            {{ station.text }}
          </option>
        </select>
      </div>
        <!-- Hidden file input -->
        <input
            type="file"
            class="d-none"
            id="photo"
            accept="gt, csv"
            @change="handleFileInput"
            ref="fileInput"
        />

      <div class="col-12 text-end mt-2">
          <button
              type="button"
              class="btn btn-outline-primary form-button"
              @click="triggerFileInput"
          >
              {{ $t('import_file_wizard.import_file') }}
          </button>

          <button
          class="form-button btn  btn-secondary"
          :disabled="loading"
          @click.stop="$emit('close')"
        >
          {{ $t('common.close') }}
        </button>
        <button
          class="form-button btn  btn-success"
          :disabled="loading || !importedLights || importedLights.length < 1 || !selectedStation"
          @click.stop="submitLights"
        >
          {{ $t('common.save') }}
        </button>
      </div>

      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from '../mixins/MapMixin'
import MapContainer from "@/components/map/MapContainer";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'StreetLightImporter',
    components: {BaseModal, MapContainer},
    mixins: [restApi, mapHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            importFile: null,
            importedLights: null,
            map: null,
            selectedStation: null,
            stations: []
        }
    },

    watch: {
        selectedStation: function () {
            if (this.importedLights) {
                this.setStationToLights()
            }
        },
        importFile() {
            this.submitFile()
        }
    },

    mounted() {
        this.fetchStations()
    },

    methods: {
        setStationToLights() {
            this.importedLights.forEach(light => light.power_station = this.selectedStation ? {id: this.selectedStation } : null)
        },
        mapChanged(map) {
            this.map = map
            if(this.getMapSettingsIn(['center'])){
                let center = this.getMapSettingsIn(['center'])
                this.map.zoomToPosition(center.lat, center.lng, this.map.getMapZoomLevel())
            }
        },
        handleFileInput(event) {
            const file = event.target.files[0]
            if (file) {
                this.importFile = file
            } else {
                this.importFile = null
            }
        },

        triggerFileInput() {
            // Trigger the file input to open the file dialog
            this.$nextTick(() => {
                const input = this.$refs.fileInput
                if (input) {
                    input.click()
                }
            })
        },
        submitFile() {
            this.hideLights()
            if (this.importFile) {
                let formData = new FormData()
                formData.append('importFile', this.importFile)
                this.loading = true
                this.restPostWithFile(this.streetLightImportUrl, {}, formData,
                    (response) => {
                        this.loading = false
                        this.importedLights = response
                        this.setStationToLights()
                        this.drawLights()
                    }, this.fail
                )
            }
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        drawLights: function () {
            this.importedLights.forEach(function (light, idx) {
                this.drawLight(light, idx+1)
            }, this)
            // Center map to first light
            this.map.zoomToGroup(this.STREET_LIGHT)
        },

        drawLight: function (light, idx) {
            let icon = this.map.getMarkerStore().getStreetLightIcon()
            this.map.showMapMarker(idx, this.STREET_LIGHT, light.position.y, light.position.x, icon)
        },

        hideLights: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.STREET_LIGHT)
            }
        },
        submitLights() {
            if (this.importedLights && this.importedLights.length > 0) {
                this.restAdd(this.streetLightBulkUrl, this.importedLights,
                    () => {
                        this.loading = false
                        this.importFile = null
                        this.hideLights()
                        this.showAlert(this.$t('street_lights.light_import_successful'), 'success')
                    }, this.fail
                )
            }
        },
        fetchStations() {
            this.loading = true
            this.stations = []
            this.restFetch(this.powerStationUrl, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                response.data.forEach(station => {
                    this.stations.push({value: station.id, text: station.id + ' ' + station.location_name})
                })
            }
            this.loading = false
        }

    }
}
</script>
